import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './playerCard.module.scss'
import { Player } from 'types/global'
import Avatar from '../Avatar'
import { ReactComponent as IconAdd } from 'images/icons/icn_add_circle.svg'
import { ReactComponent as IconClear } from 'images/icons/icn_clear.svg'
import ConfidenceTick from 'components/generic/ConfidenceTick'

interface Props {
  player: Player | null
  hasWon: boolean
  sideRef: string
  isClearable?: boolean
  onClickAdd?: () => void
  onClickClear?: () => void
}

const PlayerCard = ({
  player,
  hasWon,
  sideRef,
  isClearable = true,
  onClickAdd,
  onClickClear,
}: Props) => {
  const { t: tSocialMatches } = useTranslation('strSocialMatches')

  return (
    <div className={styles.card}>
      <div className={styles.iconContainer}>
        {player ? (
          <Avatar url={player?.avatar} size='xs' />
        ) : (
          <button onClick={onClickAdd} className={styles.addBtn} aria-label='select player'>
            <IconAdd aria-hidden />
          </button>
        )}
      </div>
      <div className={styles.playerInfoContainer}>
        <p className={styles.infoPlayer}>
          {player ? (
            <>
              {player?.fullName}
              <span className={styles.wtn}>{player.wtnSingles}</span>
              <ConfidenceTick className={styles.confidence} score={player.wtnConfidenceSingles} />
            </>
          ) : (
            <>{tSocialMatches('postScore.matchScore.playerCard.addPlayer')}</>
          )}
        </p>
        <small className={styles.infoSide}>
          {sideRef}
          {hasWon && (
            <span className={styles.winnerTag}>
              {tSocialMatches('postScore.matchScore.playerCard.winner')}
            </span>
          )}
        </small>
      </div>
      {player && isClearable && (
        <button onClick={onClickClear} className={styles.clearBtn} aria-label='clear selection'>
          <IconClear aria-hidden />
        </button>
      )}
    </div>
  )
}

export default PlayerCard
